import { gql } from '__generated__';

export default gql(`
  mutation EditDiscount($input: EditDiscountInput!) {
    editDiscount(input: $input) {
      ...DiscountFields
    }
  }
`);
